import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import AdminReports from "./AdminReports";
import SupervisorReports from "./SupervisorReports";
import { Text } from "../../design/text";

/**
 * Role-based reports page that renders different content based on user role
 */
const RoleBasedReports: React.FC = () => {
  const { role, isAdmin, isMonitor, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Text>Loading...</Text>
      </div>
    );
  }

  if (isAdmin) {
    return <AdminReports />;
  }

  if (isMonitor) {
    return <SupervisorReports />;
  }

  // Fallback
  return (
    <div className="flex items-center justify-center h-64">
      <Text className="text-zinc-500">Unknown role: {role}</Text>
    </div>
  );
};

export default RoleBasedReports;
